module.exports = __webpack_public_path__ + "static/dcw-a8712d9459792f4fab3f23a7f5cdbda7.png";